import React from 'react'
import { Container, TextBody, Icon } from '@pmi/pmi-iqos-ds-react'

const ShortestDeliveryDate = ({
  shortestDeliveryDate,
  shortestDateLabel,
  shortestDateNote
}) => {
  return (
    <Container
      display={Container.displays.flex}
      flexDirection={Container.flexDirections.row}>
      <Container pr="1">
        <Icon size={Icon.sizes.s} image={Icon.images.orders} />
      </Container>
      <Container>
        <Container pb="2">
          <TextBody
            size={TextBody.sizes.m}
            data-testing="Checkout_TextBody_ShortestDeliveryDate">
            {`${shortestDateLabel} ${shortestDeliveryDate}`}
          </TextBody>
        </Container>
        <TextBody
          size={TextBody.sizes.m}
          data-testing="Checkout_TextBody_ShortestDeliveryNote">
          {shortestDateNote}
        </TextBody>
      </Container>
    </Container>
  )
}

export default ShortestDeliveryDate
